import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "32.96vw"
        },
        card: {
            width: "100%",
            height: "45.5vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "2.35vw"
        },
        card: {
            width: "100%",
            height: "6.13vw",
            backgroundColor: Color.White
        }
    }
};

export const CandidateListLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }
    const loaderElements = new Array<any>();
    const loaderElementsCount = 10;
    for (let i = 0; i < loaderElementsCount; i++) {
        loaderElements.push(
            <div key={i} style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <circle cx="18.50%" cy="30%" r="12%" />
                        <rect x="35%" y="11.3%" rx="3" ry="3" width="37.3%" height="10.25%"/>
                        <rect x="35%" y="23.3%" rx="3" ry="3" width="40.3%" height="3.5%"/>
                        <rect x="35%" y="30.3%" rx="3" ry="3" width="18.9%" height="4.5%"/>
                        <rect x="35%" y="36.3%" rx="3" ry="3" width="50.3%" height="4%"/>
                        <rect x="35%" y="41.3%" rx="3" ry="3" width="30.3%" height="4%"/>
                        <rect x="35%" y="48.3%" rx="3" ry="3" width="18.9%" height="4.5%"/>
                        <rect x="35%" y="54.3%" rx="3" ry="3" width="30.3%" height="4%"/>
                        <rect x="35%" y="63.3%" rx="8" ry="8" width="30.3%" height="15%"/>
                    </> :
                    <>
                        <circle cx="6%" cy="40%" r="3.5%" />
                        <rect x="9.5%" y="21.7%" rx="3" ry="3" width="11.9%" height="18.2%"/>
                        <rect  x="9.5%" y="46.7%" rx="3" ry="3" width="14.3%" height="16.2%"/>
                        <rect x="32.9%" y="11.2%" rx="3" ry="3" width="8.2%" height="12.2%"/>
                        <rect x="32.9%" y="32.2%" rx="3" ry="3" width="18.2%" height="12.2%"/>
                        <rect x="32.9%" y="52.2%" rx="3" ry="3" width="11.2%" height="12.2%"/>
                        <rect x="56.8%" y="11.2%" rx="3" ry="3" width="8.2%" height="12.2%"/>
                        <rect x="56.8%" y="32.2%" rx="3" ry="3" width="11.2%" height="12.2%"/>
                        <rect x="56.8%" y="52.2%" rx="3" ry="3" width="11.2%" height="12.2%"/>
                        <rect x="89.1%" y="24.9%" rx="8" ry="8" width="9.2%" height="29.2%"/>
                    </>}                     
                </ContentLoader>
            </div>
        )
    }
    
    return (
        <div style={loaderStyles.wrapper}>
            {loaderElements}
        </div>
    );
}